module.exports = __webpack_public_path__ + "img/trophy.e2e9d9f3.svg";